import React from "react";
import { Box, CircularProgress, Grow } from "@mui/material";
import { ReactComponent as AtticusCircleLogo } from "../../assets/atticus-circle.svg";
import { styled } from "@mui/system";

const StyledLogo = styled(AtticusCircleLogo)({
  width: "100px",
  position: "absolute",
  zIndex: 999,
});

const StyledProgress = styled(CircularProgress)({
  maxWidth: "150px",
  color: "rgba(1, 217, 198, 0.5)",
  position: "absolute",
  zIndex: 1000,
});

export const AtticusCircularProgress = (): JSX.Element => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Grow in>
        <StyledLogo />
      </Grow>
      <Grow in>
        <StyledProgress size={150} />
      </Grow>
    </Box>
  );
};
